import {FC} from 'react'
import {Field, ErrorMessage} from 'formik'

const Step2: FC = () => {
    return (
    <div className='w-800px d-flex flex-column justify-content-start align-items-stretch'>
        <div className='pb-10 pb-lg-12'>
            <h2 className='fw-bolder text-dark'>Provide your Company Admin Details</h2>            
        </div>

        <div className='fv-row row gy-5'>
            <div className="col-5 mt-7 text-end">
                <label className='form-label required'>Name</label>        
            </div>
            <div className="col mb-4">
                <Field name='adminName' className='form-control form-control-solid form-control-sm' />
                <div className='text-danger'>
                    <ErrorMessage name='adminName' />
                </div>
            </div>            
        </div>

        <div className='fv-row row gy-5'>
            <div className="col-5 mt-7 text-end">            
                <label className='form-label required'>Designation</label>        
            </div>
            <div className="col mb-4">
                <Field name='adminDesignation' className='form-control form-control-solid form-control-sm' />
                <div className='text-danger'>
                    <ErrorMessage name='adminDesignation' />
                </div>
            </div>
        </div>
        <div className='fv-row row gy-5'>
            <div className="col-5 mt-7 text-end">            
                <label className='form-label required'>Contact</label>        
            </div>
            <div className="col mb-4">
                <Field name='adminContact' className='form-control form-control-solid form-control-sm' />
                <div className='text-danger'>
                    <ErrorMessage name='adminContact' />
                </div>
            </div>
        </div>
        <div className='fv-row row gy-5'>
            <div className="col-5 mt-7 text-end">            
                <label className='form-label required'>Email (Login Name)</label>        
            </div>
            <div className="col mb-4">
                <Field type="email" name='adminEmail' className='form-control form-control-solid form-control-sm' />
                <div className='text-danger'>
                    <ErrorMessage name='adminEmail' />
                </div>
            </div>
        </div>
        <div className='fv-row row gy-5'>
            <div className="col-5 mt-7 text-end">
                <label className='form-label required'>Password</label>        
            </div>
            <div className="col mb-4">                
                <Field type="password" name='adminPassword' className='form-control form-control-solid form-control-sm' />
                <div className='text-danger'>
                    <ErrorMessage name='adminPassword' />
                </div>
            </div>
        </div>
        <div className='fv-row row gy-5'>
            <div className="col-5 mt-7 text-end">
                <label className='form-label required'>Confirm Password</label>        
            </div>
            <div className="col mb-4">
                <Field type="password" name='adminPasswordConfirm' className='form-control form-control-solid form-control-sm' />
                <div className='text-danger'>
                    <ErrorMessage name='adminPasswordConfirm' />
                </div>
            </div>
        </div>
    </div>
  )
}

export {Step2}
